export const formatPercent = (value: number | undefined): string => {
  if (value === undefined || value === null) return '-';
  return `${value.toFixed(1)}%`;
};

export const formatDecimal = (value: number | undefined, decimals = 2): string => {
  if (value === undefined || value === null) return '-';
  return value.toFixed(decimals);
};
